import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { getAttendanceSheet, updateCaddyAttendance } from '../api/caddyAPI';
import swal from 'sweetalert2';

const CaddyAttendance = (props) => {

    const [selectedDate,                    setSelectedDate]                    = useState(moment().toDate());
    const [attendanceSheet,                 setAttendanceSheet]                 = useState([]);
    const [isInit,                          setIsInit]                          = useState(true);
    const [holiday,                         setHoliday]                         = useState(null);

    const history = useHistory()

    useEffect(() => {         
        props.title("Attendance", "caddy-attendance")
        $('#txtDate').datepicker({
            format: 'dd-mm-yyyy',
            endDate: new Date(),
            autoclose: true,
        });  
        $('#txtDate').on('change', function (event) {
            setSelectedDate(event.target.value)
        }); 
    }, []);

    useEffect(() => {
        fetchAttendanceSheet(selectedDate)
    }, [selectedDate])

    useEffect(() => {
        if (!isInit) fillDataTable();
    }, [attendanceSheet])

    const navigateTo = (path) => {
        history.push(path)
    }

    function fillDataTable() {

        const dataTable = $('#tblCaddyAttendance').KTDatatable({
            data: {
                saveState: false,
                source: attendanceSheet,
                pageSize: 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable: true,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Name',
                    title: 'Name',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                <div class="kt-user-card-v2__pic">
                                    ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="event-thumbail" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info">  ${row.Name.substring(0, 1)}</div>`}
                                </div>
                                <div class="kt-user-card-v2__details text-clip">
                                    <span class="kt-user-card-v2__name text-clip"> ${row.Name} </span> 
                                </div>
                            </div>`
                    },
                    width: 200,
                },
                {
                    field: 'CaddyNumber',
                    title: 'Caddy Number',
                    width: 120,
                },
                {
                    field: 'IsPresent',
                    title: 'Is Present',
                    width : 70,
                    template: function (row) {
                        return showCheckButton(row)
                    }
                },
            ]
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblCaddyAttendance .kt-datatable__table').addClass('overflow-x-auto');

        function showCheckButton(row) {
            const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');
            const todayFormattedDate = moment().format('DD-MMM-YYYY');
            const isDisabled = !moment(formattedDate, 'DD-MMM-YYYY').isSame(moment(todayFormattedDate, 'DD-MMM-YYYY'), 'day');
            let opt = `
                <span class="kt-switch kt-switch--sm kt-switch--icon margin-lr10">
                    <label class="margin-b0 padding-t5">
                        <input 
                            id="caddy-present" 
                            class="caddy-present" 
                            name="caddy-present"
                            type="checkbox" 
                            ${row.IsPresent == 'Y' ? 'Checked' : ''} 
                            data-id="${row.ID}"
                            ${isDisabled ? 'disabled' : ''}
                        />
                        <span></span>
                    </label>
                </span>
            `
            return opt
        }

        $('#tblCaddyAttendance').on('change', '.caddy-present', function () {
            const isChecked = this.checked;
            const dataId = this.getAttribute('data-id');    
            handleCheckBox(dataId, isChecked);
        });
    }
    
    async function handleCheckBox(dataId, isChecked) {
        try {
            await updateCaddyAttendance(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), dataId, isChecked ? 'Y' : 'N') 
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const fetchAttendanceSheet = async(date) => {
        try {
            const {attendanceSheet, holiday} = await getAttendanceSheet(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'));
            isInit ? setIsInit(false) : $('#tblCaddyAttendance').KTDatatable().destroy(); 
            setAttendanceSheet(attendanceSheet)
            setHoliday(holiday)
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    return (
        <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-b0" id="kt_content" style={{paddingTop: '0px'}}>
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                <div className="kt-portlet kt-portlet--mobile">
                    <div className="kt-portlet__body kt-portlet__body--fit padding-t20 padding-b0">
                        <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 border-bottom-light" role="form">
                            <div className="row">
                                <label className="col-form-label col-sm-2 text-right">Date </label>
                                <div className="form-group  col-sm-3">
                                    <div className="input-group date">
                                        <input 
                                            id="txtDate" 
                                            name="txtDate" 
                                            type="text" 
                                            className="form-control" 
                                            defaultValue={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            placeholder="Select date" 
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text">
                                                <i className="la la-calendar-check-o"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group col-sm-3">
                                    <div className="kt-input-icon kt-input-icon--left">
                                        <input type="text" className="form-control clientSearch" placeholder="Search Caddy..." id="generalSearch" />
                                        <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                    </div>
                                </div>

                                <div className="form-group  col-sm-3">
                                    <span id="btnQueue" className="btn btn-success" onClick={() => navigateTo('/caddy-queue')}>Caddy Queue <i className="fa fa-angle-right"></i></span>
                                </div>
                            </div>
                            {holiday && (
                                <div className="row">
                                    <div className="form-group col-sm-12 vertical-center mb-1">
                                        <h6 className="text-center text-danger mb-0"><span id="lblHoliday">Bank Holiday: {holiday.Name}</span></h6>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div id="tblCaddyAttendance" className="kt-datatable table-striped "></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaddyAttendance